(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _var_www_vhosts_weprofit_global_httpdocs_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(683);
/* harmony import */ var components_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(981);
/* harmony import */ var components_pages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6188);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);

var _excluded = ["pages", "global", "pageParams", "selectedLang"];
 //* HOC's

 //* Component





var Home = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function (_ref) {
  var pages = _ref.pages,
      global = _ref.global,
      pageParams = _ref.pageParams,
      selectedLang = _ref.selectedLang,
      props = (0,_var_www_vhosts_weprofit_global_httpdocs_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var data = {
    firsSection: {
      text: 'WeProfit is a global marketplace matching and enabling companies to do digital business '
    },
    secondSection: [{
      title: 'Quality',
      text: 'Our vetted suppliers guarantee an efficient matching and world class project delivery.'
    }, {
      title: 'Speed',
      text: 'Due to our intense screening and preparation your coding can start after days.'
    }, {
      title: 'Security',
      text: 'Your contracting, payment & data is safe on our platform framework.'
    }, {
      title: 'Digital',
      text: 'Get best practice and guidance through our intuitive and simple customer journey.'
    }],
    thirdSection: [{
      title: 'Buyer',
      text: 'Post new software development projects at any time in any industry and find matching supplier companies.',
      img: '/video/Buyer.mp4',
      benefitsItem: ['A qualitative and <strong>cost-efficient</strong> way to outsource <em>software development tasks</em> for your <strong>business.</strong>', 'Intuitive and smooth <strong>user experience </strong>combined with <em>unprecedented global resources.</em>', '<strong>Secure, transparent and digital</strong> access to a <em> diverse and filtered database </em> of <strong>suppliers.</strong>']
    }, {
      title: 'Supplier',
      text: 'Present your portfolio, find new projects, compete on global markets and grow.',
      img: '/video/Supplier.mp4',
      benefitsItem: ['Unique exposure on <em>international markets</em> via the <strong>WeProfit marketplace.</strong>', 'Easy and <em>efficient</em> way to attract new customers on a <strong>new market.</strong>', '<strong>Professionalization</strong> through inclusion in <em>global competition.</em>']
    }, {
      title: 'Connector',
      text: 'Use your network to connect projects with suitable suppliers and earn your commission.',
      img: null,
      benefitsItem: ['Participation on <em>successful matches</em> via <strong>commission.</strong>', '<strong>Contributing</strong> to a newly conceived <em>international cooperation.</em>', 'Digital and <em>intuitive access</em> to a professional <strong>global community.</strong>']
    }],
    fourthSection: ['Enterprise software development', 'Web design', 'Mobile app development', 'Web application', 'SaaS ', 'PaaS/loT', 'AI/ML', 'Blockchain'],
    fifthSection: {
      descripion: 'The WeProfit process will allow you to easily post / apply and process software development projects.',
      items: [{
        title: 'Post / Apply',
        text: 'As a buyer the weprofit project scope generator will guide you through the creation of a precise and efficient project scope. As a Supplier you can bid on posted projects and negotiate the most important points to kick off a successful collaboration.'
      }, {
        title: 'Matching',
        text: 'Match with the most fitting software development Supplier after scoping your project. Match as Supplier with your ideal clients and create suitable matches as Connector.'
      }, {
        title: 'Processing',
        text: 'Use the intuitive user experience to configure, negotiate and conduct your software development projects. Simple, fast and uncomplicated.'
      }]
    },
    sixthSection: ['images/home/OurPartners/img1.svg', 'images/home/OurPartners/img2.svg', 'images/home/OurPartners/img3.svg', 'images/home/OurPartners/img4.svg', 'images/home/OurPartners/img5.svg'],
    sevenSection: {
      text: 'Post your software development project as a Buyer or apply for new and interesting projects as a Supplier.'
    },
    eighthSeection: [{
      title: 'Mobile App - MVP',
      text: 'Building and development of a blockchain mobile app from wireframes.',
      img: 'images/home/brandYooba.svg',
      quote: '“With the help of WeProfit, we found a company that built our first mobile app and supported us like a technical founder in the development process.”',
      autorName: 'Lukas Weniger',
      autorImg: '/images/home/Lukas.jpeg',
      autorPosition: 'Co-Founder'
    }, {
      title: 'Web-Software (SaaS)',
      text: 'Development of a multifunctional scraper and a database for the LegalTech product “Lexguard”.',
      quote: '“WeProfit is the platform we always find ourselves coming back to. Adding functionalities to our existing software or creating new tools from scratch, WeProfit got it covered.”',
      img: 'images/home/brandLexemo.svg',
      autorName: 'Pascal DiPrima',
      autorImg: '/images/home/pscal.jpeg',
      autorPosition: 'CEO'
    }, {
      title: 'Mobile App',
      text: 'Adding key functionalities to our mobile application for our KYC product',
      img: 'images/home/brandQundo.svg',
      quote: '“We needed to add a lot of functionalities to our App in a short period of time. Through WeProfit,  we found a partner and got the project off the ground quickly without cutting corners on quality.”',
      autorName: 'Julian Metzler',
      autorImg: '/images/home/JulianMetzler.jpg',
      autorPosition: 'CTO'
    }],
    lastSection: [{
      title: '2 factor authentication',
      text: 'Will secure your account from outside'
    }, {
      title: 'Servers hosted in germany',
      text: 'It is reliable, safe and of high quality'
    }, {
      title: 'TLS encryption',
      text: 'Stands for hypertext transfer protocol secure'
    }, {
      title: 'Secure payments',
      text: 'We will secure your payments with  escrow systems'
    }, {
      title: 'Strong data governance',
      text: 'High quality data management through all phases of the data lifecycle'
    }, {
      title: 'Compliant with EU-GDPR',
      text: 'Your data is processed according to the highest standards'
    }]
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(components_common__WEBPACK_IMPORTED_MODULE_2__/* .Page */ .T3, {
    className: "home",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_3__/* .HeroSection */ .DH, {
      data: data.firsSection
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_3__/* .LoveWeprofitSection */ .Kc, {
      data: data.secondSection
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_3__/* .CustomerTypeSection */ .Hy, {
      data: data.thirdSection
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_3__/* .TopCategoriesSection */ .oc, {
      data: data.fourthSection
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_3__/* .HowItWorksSection */ .c1, {
      data: data.fifthSection
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_common__WEBPACK_IMPORTED_MODULE_2__/* .OurPartners */ .OQ, {
      data: data.sixthSection,
      marginBottom: true
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_3__/* .LookingHireSection */ .Yy, {
      data: data.sevenSection.text
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_3__/* .SliderSection */ .oF, {
      data: data.eighthSeection
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_pages__WEBPACK_IMPORTED_MODULE_3__/* .DataSecuritySection */ .te, {
      data: data.lastSection
    })]
  });
});
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_1__/* .withLanguageContext */ .VZ)((0,context__WEBPACK_IMPORTED_MODULE_1__/* .withDataContext */ .hX)(Home, ['pages', 'global']), ['selectedLang']));

/***/ }),

/***/ 8581:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8265);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,188,774,888,179], function() { return __webpack_exec__(8581); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);